import { render, staticRenderFns } from "./ProjectPlan.vue?vue&type=template&id=28e17397&scoped=true&"
import script from "./ProjectPlan.vue?vue&type=script&lang=js&"
export * from "./ProjectPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e17397",
  null
  
)

export default component.exports